// ✅ App.jsx (Main Entry Point)

import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { MoonLoader } from "react-spinners";
import LoginButton from "./components/LoginButton";
import OrdersTable from "./components/OrdersTable";
import BulkControls from "./components/BulkControls";
import SyncControls from "./components/SyncControls";
import useOrders from "./hooks/useOrders";
import PushSummaryOverlay from "./components/PushSummaryOverlay";
import extractAndStoreToken from "./utils/auth";

const App = () => {
  const {
    orders,
    totalPages,
    currentPage,
    setCurrentPage,
    fetchOrders,
    updateDatabase,
    pushToZippie,
    bulkPushToZippee,
    fetchAllOrderIds,
    selectedOrders,
    toggleOrderSelection,
    isOrderSelected,
    loading,
    shopifyToken,
    setShopifyToken,
    startDateTime,
    setStartDateTime,
    endDateTime,
    setEndDateTime,
    deliveryFilter,
    setDeliveryFilter,
    pushSummary,
    setPushSummary
  } = useOrders();

  useEffect(() => {
    const token = localStorage.getItem("shopifyToken");
    if (token) {
      setShopifyToken(token);
      fetchOrders(currentPage);
    }
  }, [currentPage, shopifyToken]);

  /* Set the token */
  useEffect(() => {
    const token = extractAndStoreToken();
    if (token) setShopifyToken(token);
  }, []);

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Shopify → Zippee Order Fulfilment by Toposel</h2>

      {!shopifyToken ? (
        <LoginButton />
      ) : (
        <>
          {loading && (
            <div style={styles.overlay}><MoonLoader color="#0c60ff" size={50} /></div>
          )}

          <SyncControls
            startDateTime={startDateTime}
            endDateTime={endDateTime}
            setStartDateTime={setStartDateTime}
            setEndDateTime={setEndDateTime}
            updateDatabase={updateDatabase}
            deliveryFilter={deliveryFilter}
            setDeliveryFilter={setDeliveryFilter}
          />

          <BulkControls
            fetchAllOrderIds={fetchAllOrderIds}
            bulkPushToZippee={bulkPushToZippee}
            selectedOrders={selectedOrders}
            currentPage={currentPage}
          />

          <OrdersTable
            orders={orders}
            isOrderSelected={isOrderSelected}
            toggleOrderSelection={toggleOrderSelection}
            pushToZippie={pushToZippie}
          />


        <div className="d-flex justify-content-between align-items-center mt-3">
        <button
            className="btn btn-secondary"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
        >
            ← Previous
        </button>

        <div className="d-flex align-items-center">
            <span className="mr-2">Page</span>
            <select
            className="form-control"
            value={currentPage}
            onChange={(e) => setCurrentPage(Number(e.target.value))}
            >
            {Array.from({ length: totalPages }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                {i + 1}
                </option>
            ))}
            </select>
            <span className="ml-2">of {totalPages}</span>
        </div>

        <button
            className="btn btn-secondary"
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
        >
            Next →
        </button>
        </div>




        </>
      )}

        {pushSummary && (
        <PushSummaryOverlay
            summary={pushSummary}
            onClose={() => setPushSummary(null)}
        />
        )}

    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  }
};

export default App;
